import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { CHECKSUM_CHANGE_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { CHECKSUM_CHANGE_REPORT } from "../interfaces/dashboard";

export default function ChecksumChangeReport() {
    const checksumChangeReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.CHECKSUM_CHANGE_REPORT;

    const [checksumChangeReportTableData, setCardStatusReportTableData] = useState<CHECKSUM_CHANGE_REPORT[]>([]);

    useEffect(() => {
        setCardStatusReportTableData(CHECKSUM_CHANGE_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="CHECKSUM_CHANGE_REPORT"
        tableColumns={checksumChangeReportTableColumns}
        tableData={checksumChangeReportTableData} />
    );
}